export const LD2450_MAX_DISTANCE_MM = 8000;
export const LD2450_FOV_DEGREES = 120;
export const LD2450_ZONE_MIN_X_MM = -4860;
export const LD2450_ZONE_MAX_X_MM = 4860;
export const LD2450_ZONE_MIN_Y_MM = 0;
export const LD2450_ZONE_MAX_Y_MM = 7560;

export const MAX_SOFTWARE_ZONES = 6;
export const MAX_CALIBRATION_ZONES = 4;
export const MAX_ZONE_POINTS = 8;
export const RADAR_ROOM_CONTEXT_COVERAGE_STEPS = 8;
export const MAX_FLOORPLAN_ROOM_BOUNDARY_POINTS = MAX_ZONE_POINTS + RADAR_ROOM_CONTEXT_COVERAGE_STEPS + 2;
export const MAX_ZONE_NAME_LENGTH = 10;
export const EXIT_LINE_STRIP_WIDTH_MM = 300;

export const CALIBRATION_MIN_MS = 15000;
export const CALIBRATION_MAX_MS = 60000;
export const CALIBRATION_MIN_SAMPLES = 20;
export const CALIBRATION_SCORE_THRESHOLD = 80;
export const CALIBRATION_MAX_CLUSTER_WIDTH_MM = 2400;
export const CALIBRATION_MAX_CLUSTER_HEIGHT_MM = 2400;
export const CALIBRATION_MAX_CLUSTER_AREA_MM2 = 3600000;
export const CALIBRATION_OUTLIER_DISTANCE_MM = 1200;
export const CALIBRATION_PERCENTILE_LOW = 0.05;
export const CALIBRATION_PERCENTILE_HIGH = 0.95;
export const CALIBRATION_MIN_BOX_SIZE_MM = 800;
export const CALIBRATION_BOX_MARGIN_MM = 700;
